function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg048NewZealand(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#0052B4"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "445.95,216.686 451.033,232.328 467.478,232.328 454.173,241.993 459.255,257.635    445.95,247.968 432.644,257.635 437.728,241.993 424.422,232.328 440.868,232.328  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "387.161,329.295 394.785,352.758 419.454,352.758 399.495,367.256 407.119,390.718    387.161,376.219 367.203,390.718 374.827,367.256 354.868,352.758 379.537,352.758  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "389.382,145.025 395.735,164.578 416.292,164.578 399.661,176.66 406.014,196.212    389.382,184.127 372.75,196.212 379.104,176.66 362.471,164.578 383.028,164.578  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "332.814,216.004 340.438,239.467 365.106,239.467 345.148,253.965 352.772,277.427    332.814,262.928 312.855,277.427 320.48,253.965 300.522,239.467 325.19,239.467  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "256,0.002 256,48.898 215.853,89.046 256,89.046 256,166.959 203.464,166.959 256,219.494   256,256.002 232.281,256.002 166.957,190.667 166.957,256.002 89.043,256.002 89.043,178.278 11.331,256.002 0,256.002 0,207.106   40.147,166.959 0,166.959 0,89.046 52.536,89.046 0,36.51 0,0.002 23.719,0.002 89.043,65.338 89.043,0.002 166.957,0.002   166.957,77.726 244.669,0.002 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.002 104.001,152.002 104.001,256.002 152.001,256.002 152.001,152.002 256,152.002   256,104.002 152.001,104.002 152.001,0.002 104.001,0.002 104.001,104.002 0,104.002 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.959 256,256.002 256,230.822 192.137,166.959 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.959 256,256.002 256,230.822 192.137,166.959 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.959 256,256.002 256,230.822 192.137,166.959  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.961 0,230.823 0,256.002 0,256.002 89.041,166.961  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.046 0,0.002 0,25.183 63.863,89.046 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.046 0,0.002 0,25.183 63.863,89.046 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.046 0,0.002 0,25.183 63.863,89.046  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.043 256,25.181 256,0.002 256,0.002 166.959,89.043  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg048NewZealand);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };